import { Button, Col, Form, InputGroup } from 'react-bootstrap';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';

export default function EmailForm() {
  const { t } = useTranslation();

  return (
    <Col md={6} lg={12}>
      <h3>Nieuwsbrief</h3>
      <p>Blijf op de hoogte!</p>
      <InputGroup className="mb-3">
        <Form.Control type="email" placeholder="Jouw emailadres" />
        <Button type="submit" size="lg">
          {t('common:actions.signup')}
        </Button>
      </InputGroup>
    </Col>
  );
}
